import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/service/auth.service';
import { CommonService } from 'src/app/service/common.service';
import { GenericValidator } from 'src/app/validation/general-validation';
import { GSMConfigurationService } from 'src/app/Service/gsmconfiguration.service';
import { DashBoardService } from 'src/app/service/dashboard.service';
import { AdddashboardComponent } from '../adddashboard/adddashboard.component';

@Component({
  selector: 'app-addnewdashboard',
  templateUrl: './addnewdashboard.component.html'
})
export class AddnewdashboardComponent implements OnInit {

  isdisplayNoofRegisterinput: boolean = false;
  DashboardName: string = '';
  UserPrefData: any[] = [];
  CompanyIdforUC: number = 0;
  SiteList: any[] = [];
  PanelList: any[] = [];
  EnergymeterList: any[] = [];
  RegisterData: any[] = [];
  errorMsg: string = '';
  successMsg: string = '';
  SiteId: string = '';
  companycode: string;
  PanelId: string = '';
  MeterId: string = '';
  SiteName: string = '';
  PanelName: string = '';
  EnergymeterName: string = '';
  RegisterName: string = '';
  RegisterDataId: number = 0;
  newdashboardform: FormGroup;
  displayMessage: { [key: string]: string } = {};
  private genericValidator: GenericValidator;
  private validationMessages: { [key: string]: { [key: string]: string } };
  DashboardConfigData: any[] = [];
  RegisterDataList = [];
  RegisterDataList1 = [];
  DashbaordName: any;
  TotalRegisterVal: number;
  CreatedUser: any;
  DropDownList: any;
  ValueTypeList: any;

  constructor(private commonservice: CommonService, private dialog: MatDialog, public dialogRef: MatDialogRef<AddnewdashboardComponent>, private form: FormBuilder, private authService: AuthService, private GSMConfigService: GSMConfigurationService, private dashboardservice: DashBoardService) {
    // Raise Validation message
    this.authService.getValidationMessage().subscribe(resp => {
      this.validationMessages = resp.newdashboardform;
      this.genericValidator = new GenericValidator(this.validationMessages);
    });
  }

  ngOnInit(): void {
    this.CompanyIdforUC = +localStorage.getItem('CompanyIdForUC');
    this.GetSiteList(this.CompanyIdforUC);
    this.companycode = localStorage.getItem('CompanyCode');


    this.newdashboardform = this.form.group({
      DashboardId: [],
      CardMeterConfigurationType: ['', [Validators.required]],
      TotalRegister: [''],
      SiteId: ['', [Validators.required]],
      PanelId: ['', [Validators.required]],
      MeterId: ['', [Validators.required]],
      RegisterDataId: ['', [Validators.required]],
      ValueType: ['']
    });

    this.GetValueTypeData();
    this.GetDashboardConfigData();

    // Call service for validation on valu change
    this.newdashboardform.valueChanges.subscribe(
      value => this.displayMessage = this.genericValidator.processMessages(this.newdashboardform)
    );

  }

  // Get Value Type Data
  GetValueTypeData() {
    this.GSMConfigService.Getdropdownlist('ValueType').subscribe(
      (result) => {
        this.DropDownList = result;
        this.ValueTypeList = this.DropDownList['listvalueType'];
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }

  // Display Textbox as per selection of Card configuration type
  DisplayTextBox(radiobtnVal: string) {
    if (this.DashboardConfigData[0].CardMeterConfigurationType == "Single Card Per Meter" && radiobtnVal == "Single") {
      this.RegisterDataList = this.RegisterDataList1;
    }
    else if (this.DashboardConfigData[0].CardMeterConfigurationType == "Multiple Card Per Meter" && radiobtnVal == "Multiple") {
      this.RegisterDataList = this.RegisterDataList1;
    }
    else {
      this.RegisterDataList = [];
    }
    if (radiobtnVal === 'Single') {
      this.isdisplayNoofRegisterinput = true;
    }
    else {
      this.isdisplayNoofRegisterinput = false;
    }
  }

  // Get Dashboard Config Data
  GetDashboardConfigData() {
    this.errorMsg = '';
    this.dashboardservice.GetDashboardConfigData(this.CompanyIdforUC).subscribe(
      (lstdashbaordconfigdata) => {
        if (lstdashbaordconfigdata.length > 0) {
          this.DashboardConfigData = lstdashbaordconfigdata;
          this.RegisterDataList = lstdashbaordconfigdata[0].registerDataLists;
          this.RegisterDataList1 = lstdashbaordconfigdata[0].registerDataLists;
          this.DashbaordName = this.DashboardConfigData[0].DashboardName;
          this.CreatedUser = this.DashboardConfigData[0].CreatedUser;
          this.newdashboardform.patchValue({
            CardMeterConfigurationType: this.DashboardConfigData[0].CardMeterConfigurationType,
            TotalRegister: this.DashboardConfigData[0].TotalRegister,
            DashboardId: this.DashboardConfigData[0].DashboardId
          })

          if (this.newdashboardform.value.CardMeterConfigurationType == 'Multiple Card Per Meter') {
            this.isdisplayNoofRegisterinput = false;
          }
          else {
            this.newdashboardform.patchValue({
              CardMeterConfigurationType: 'Single Card Per Meter'
            })
            this.isdisplayNoofRegisterinput = true;
          }
        }
        else {
          this.errorMsg = 'No Data Found';
          return;
        }

      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }

  //Get Site List
  GetSiteList(CompanyId) {
    this.commonservice.GetSiteList(CompanyId).subscribe(
      (result) => {
        this.SiteList = result;
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }

  //Get Panel List
  GetPanelList(SiteId) {
    this.commonservice.GetPanelList(SiteId).subscribe(
      (result) => {
        this.PanelList = result;
        if (this.PanelList.length == 1) {
          this.newdashboardform.patchValue({
            PanelId: this.PanelList[0].CodeValue,
          });
          this.GetEnergymeterList(this.SiteId, 0)
        }
      },
      (error) => {
        this.errorMsg = error;
      }
    );
    // this.GetEnergymeterList(this.SiteId, 0)
  }

  //Get Energy meter List
  GetEnergymeterList(SiteId, PanelId) {
    this.commonservice.GetEnergyMeterIdList(SiteId, PanelId, 'N').subscribe(
      (result) => {
        if (result.length > 0) {
          this.EnergymeterList = result;
          if (this.EnergymeterList.length == 1) {
            this.newdashboardform.patchValue({
              MeterId: this.EnergymeterList[0].CodeValue
            });
            this.GetRegisterdata(this.EnergymeterList[0].CodeValue);
          }
        }
      },
      (error) => {
        this.errorMsg = error;

      }
    );
  }

  // Called on change Site
  OnChangeSite(event) {
    this.newdashboardform.patchValue({
      SiteId: event.value
    });
    this.SiteId = event.value;
    this.SiteName = event.source.triggerValue;
    this.GetPanelList(event.value);
    // this.GetEnergymeterList(this.SiteId, 0);
    this.newdashboardform.patchValue({
      PanelId: '',
      MeterId: ''
    });
    if (event.value == '') {
      this.PanelList = []
      this.EnergymeterList = []
      this.RegisterData = []
    }
  }

  // Called on change Panel
  OnChangePanel(event) {
    this.newdashboardform.patchValue({
      PanelId: event.value
    });
    this.PanelId = event.value;
    this.PanelName = event.source.triggerValue;
    this.GetEnergymeterList(this.SiteId, this.PanelId);
    this.newdashboardform.patchValue({
      MeterId: ''
    });
    if (event.value == '') {
      this.EnergymeterList = []
      this.RegisterData = []
    }
  }

  // Called on chenge Energymeter
  OnChangeEnergymeter(event) {
    this.newdashboardform.patchValue({
      MeterId: event.value
    });
    this.MeterId = event.value;
    this.EnergymeterName = event.source.triggerValue;
    this.GetRegisterdata(this.MeterId);
    this.newdashboardform.patchValue({
      RegisterDataId: ''
    });
    if (event.value == '') {
      this.RegisterData = []
    }
  }

  // Get Register Data
  GetRegisterdata(id) {
    if (id != null) {
      this.GSMConfigService.GetRegisterdata(id, 'N', 'N', 'Y').subscribe(
        (result) => {
          if (result.listRegisterdata != null) {
            this.RegisterData = result.listRegisterdata;
            if (this.RegisterData.length == 1) {
              this.newdashboardform.patchValue({
                RegisterDataId: this.RegisterData[0].CodeValue
              });
            }
          }
        },
        (error) => {
          this.errorMsg = error;
        }
      )
    }
  }

  // Close Icon event
  Close() {
    this.dialogRef.close();
  }

  // Save Dashboard Data
  SaveDashboardData(reqparam) {
    this.errorMsg = '';
    this.successMsg = '';
    this.dashboardservice.SaveDashoardConfigData(reqparam).subscribe(
      (lstdashbaordconfigdata) => {
        if (lstdashbaordconfigdata && lstdashbaordconfigdata.length > 0) {
          this.DashboardConfigData = lstdashbaordconfigdata;
          this.RegisterData = this.DashboardConfigData[0].registerDataLists;
          this.DashboardName = this.DashboardConfigData[0].DashboardName;
          this.CreatedUser = this.DashboardConfigData[0].CreatedUser;

          this.newdashboardform.patchValue({
            CardMeterConfigurationType: this.DashboardConfigData[0].CardMeterConfigurationType,
            TotalRegister: this.DashboardConfigData[0].TotalRegister
          })

          if (this.newdashboardform.value.CardMeterConfigurationType == 'Multiple Card Per Meter') {
            this.isdisplayNoofRegisterinput = false;
          }

          this.successMsg = 'Data saved successfully!!';
        }
        else {
          return;
        }
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }

  // On Add button click
  AddRegisterData() {
    this.errorMsg = '';
    this.successMsg = '';

    if (!this.isdisplayNoofRegisterinput) {
      this.newdashboardform.controls['ValueType'].setValidators([Validators.required]);
      this.newdashboardform.controls['ValueType'].updateValueAndValidity();
      this.newdashboardform.controls['TotalRegister'].clearValidators();
      this.newdashboardform.controls['TotalRegister'].updateValueAndValidity();
    }
    else {
      this.newdashboardform.controls['ValueType'].clearValidators();
      this.newdashboardform.controls['ValueType'].updateValueAndValidity();
      this.newdashboardform.controls['TotalRegister'].setValidators([Validators.required]);
      this.newdashboardform.controls['TotalRegister'].updateValueAndValidity();
    }
    if (this.newdashboardform.invalid) {
      this.newdashboardform.updateValueAndValidity();
      this.displayMessage = this.genericValidator.processMessages(this.newdashboardform, this.newdashboardform.invalid);
      return;
    }

    this.TotalRegisterVal = this.newdashboardform.value.TotalRegister;

    var meter = this.EnergymeterList.filter(s => s.CodeValue == this.newdashboardform.value.MeterId)[0].CodeDisplayText;
    var register = this.RegisterData.filter(s => s.RegisterDataId == this.newdashboardform.value.RegisterDataId)[0].RegisterName;

    this.RegisterDataList = this.RegisterDataList || [];
    if (!this.isdisplayNoofRegisterinput) {
      var valuetype = this.ValueTypeList.filter(s => s.CodeValue == this.newdashboardform.value.ValueType)[0].CodeDisplayName;
      var existRegister = this.RegisterDataList ? this.RegisterDataList.filter(r => r.RegisterName == register && r.MeterName == meter && r.ValueTypeName == valuetype) : null;
    }
    else {
      var existRegister = this.RegisterDataList ? this.RegisterDataList.filter(r => r.RegisterName == register && r.MeterName == meter) : null;
    }


    var existMeter = this.RegisterDataList ? this.RegisterDataList.filter(r => r.MeterName == meter) : null;


    if (existRegister.length > 0) {
      this.errorMsg = !this.isdisplayNoofRegisterinput ? 'Register and Value type already exist with selected Meter!!' : 'Register already exist with selected Meter!!'
      return false;
    }

    this.RegisterDataList.push({
      CompSiteName: this.SiteList.filter(s => s.CodeValue == this.newdashboardform.value.SiteId)[0].CodeDisplayText,
      CompPanelName: this.PanelList.filter(s => s.CodeValue == this.newdashboardform.value.PanelId)[0].CodeDisplayText,
      MeterName: this.EnergymeterList.filter(s => s.CodeValue == this.newdashboardform.value.MeterId)[0].CodeDisplayText,
      RegisterName: this.RegisterData.filter(s => s.RegisterDataId == this.newdashboardform.value.RegisterDataId)[0].RegisterName,
      CompSiteId: this.newdashboardform.value.SiteId,
      CompPanelId: this.newdashboardform.value.PanelId,
      EnergymeterMasterID: this.newdashboardform.value.MeterId,
      RegisterDataId: this.newdashboardform.value.RegisterDataId,
      ValueType: this.newdashboardform.value.ValueType,
      ValueTypeName: !this.isdisplayNoofRegisterinput ? this.ValueTypeList.filter(s => s.CodeValue === this.newdashboardform.value.ValueType)[0].CodeDisplayName : '',
      EnergymeterID: this.EnergymeterList.filter(s => s.CodeValue == this.newdashboardform.value.MeterId)[0].EnergymeterId
    })
  }

  // Delete Data from Locally
  DeleteRegisterData(MeterId, RegisterName) {
    this.successMsg = '';
    this.errorMsg = '';
    let index = this.RegisterDataList.findIndex(x => x.RegisterName == RegisterName && x.EnergymeterID === MeterId);
    this.RegisterDataList.splice(index, 1);
  }

  // Send Param for Save Dashboard Data
  SendSaveDashboardData() {
    this.errorMsg = '';
    this.successMsg = '';

    if (!this.RegisterDataList || this.RegisterDataList.length == 0) {
      this.errorMsg = 'Please add atleast one register!!';
      return false;
    }


    let reqparam = {
      isForTable: 'DashboardData',
      DashboardId: this.newdashboardform.value.DashboardId > 0 ? this.newdashboardform.value.DashboardId : 0,
      listDashboarddata: this.RegisterDataList,
      CompanyId: this.CompanyIdforUC,
      TotalRegister: this.newdashboardform.value.TotalRegister > 0 ? this.newdashboardform.value.TotalRegister : 0,
      CardMeterConfigurationType: this.newdashboardform.value.CardMeterConfigurationType
    };
    this.SaveDashboardData(reqparam);
  }

  // Open Dashboard Popup
  OpenDahbaordPopup() {
    this.errorMsg = '';
    this.successMsg = '';
    const dashboardconfig = this.dialog.open(AdddashboardComponent, {
      width: '400px',
      height: '200px',
      data: {
      }
    });

    dashboardconfig.afterClosed().subscribe(
      (result) => {
        if (result) {
          this.DashboardName = result;

          let reqparam = {
            isForTable: 'DashboardConfig',
            DashboardName: this.DashboardName,
            listDashboarddata: this.RegisterDataList,
            CompanyId: this.CompanyIdforUC,
            TotalRegister: this.newdashboardform.value.TotalRegister > 0 ? this.newdashboardform.value.TotalRegister : 0,
            CardMeterConfigurationType: this.newdashboardform.value.CardMeterConfigurationType
          };
          this.SaveDashboardData(reqparam);
        }
      }
    )
  }

}
